export enum PagePosition {
  /**
   * 顶部
   */
  TOP = 0,
  /**
   * 中间
   */
  MIDDLE = 1,
  /**
   * 底部
   */
  BOTTOM = 2
}

export const PagePositionTextMap: Record<PagePosition, string> = {
  [PagePosition.TOP]: '顶部',
  [PagePosition.MIDDLE]: '中间',
  [PagePosition.BOTTOM]: '底部'
}
